import { useCallback } from "react";

import useClient from "hooks/useClient";

const useFindContractPdf = (): {
  findContractPdf: (contractId: string) => Promise<Attachment>;
} => {
  const { client } = useClient();

  const findContractPdf = useCallback(
    async (contractId: string) => {
      const { data } = await client<Attachment, unknown>({
        method: "get",
        url: `/contract/unanswered-contract-pdf/${contractId}`,
      });
      return data;
    },
    [client]
  );

  return { findContractPdf };
};

export default useFindContractPdf;
